import { UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { t } from "i18next";
export const inputsAddresseItem = ({
  description = "",
  address,
  sharedToInstitutions,
  changeEdition = null,
}) => {
  const inputs = [
    {
      children: [
        {
          name: "description",
          label: t("inputsAddresseItem.description"),
          value: description,
          required: true,
          type: "input",
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("inputsAddresseItem.addressLabel"),
      children: [
        {
          label: t("inputsAddresseItem.address"),
          name: "d",
          addonBefore: <UserOutlined />,
          type: "addressForm",
          values: address,
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("inputsAddresseItem.shareAddressLabel"),
      children: [
        {
          label: t("inputsAddresseItem.institutions"),
          name: "sharedToInstitutions",
          value: sharedToInstitutions || [],
          type: "dynamic-select",
          required: false,
          multiple: true,
          quote: (
            <>
              <p>{t("inputsAddresseItem.institutionsQuote")}</p>
            </>
          ),
          quoteIcon: "info",
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
      ],
    },
  ];

  if (changeEdition !== null) {
    inputs[2].children.push({
      label: t("inputsAddresseItem.save"),
      type: "submit",
      size: "small",
    });

    inputs[2].children.push({
      type: "component",
      component: () => (
        <Button
          onClick={changeEdition}
          size={"small"}
          type={"primary"}
          style={{ marginRight: 10 }}
        >
          {t("inputsAddresseItem.cancel")}
        </Button>
      ),
    });
  }

  return inputs;
};
